import React, { Component } from 'react';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import { Card } from 'primereact/card';
import { Dropdown } from 'primereact/dropdown';
import { InputText } from 'primereact/inputtext';
import { Panel } from 'primereact/panel';
import { Divider } from 'primereact/divider';
import { ProgressSpinner } from 'primereact/progressspinner';
import { Row, Col } from 'react-bootstrap';
import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_BASEURL_CLIENT_BACKEND || 'http://10.0.4.29:4000';

class TemplatePreview extends Component {
    constructor(props) {
        super(props);
        this.state = {
            viewMode: 'both', // 'front', 'back', 'both'
            cardData: {
                id: '152',
                name: 'DOE',
                firstName: 'John',
                birthDate: new Date().toISOString(),
                idNumber: '152',
                nationality: 'Liberian',
                signature: '',
                expiryDate: new Date(new Date().setFullYear(new Date().getFullYear() + 10)).toISOString(),
                serialNumber: '',
                policeNumber: 'POL123456',
                souscripteur: 'SUBSCRIBER NAME',
                familyId: '',
                beneficiaryId: '1309',
                insuranceCompany: 'Acare',
                policyType: 'Standard'
            },
            previewOptions: {
                quality: 'Medium',
                showCutLines: false,
                showSafeZones: false,
                showBleedArea: false,
                highlightFields: false,
                background: 'White',
                scaleFactor: 1,
                watermarkEnabled: true,
                watermarkText: 'APERÇU'
            },
            zoomLevel: 100,
            previewImageFront: null,
            previewImageBack: null,
            loadingPreview: false,
            previewError: null,
            photoBase64: null // Placeholder photo
        };
    }

    componentDidUpdate(prevProps) {
        // Load preview when template changes or dialog opens
        if (this.props.visible && !prevProps.visible && this.props.template) {
            this.generatePlaceholderPhoto().then(() => {
                this.loadPreview('Front');
                this.loadPreview('Back');
            });
        }
    }

    componentWillUnmount() {
        // Clean up object URLs to prevent memory leaks
        this.cleanupObjectURLs();
    }

    cleanupObjectURLs = () => {
        const { previewImageFront, previewImageBack } = this.state;
        if (previewImageFront && previewImageFront.startsWith('blob:')) {
            URL.revokeObjectURL(previewImageFront);
        }
        if (previewImageBack && previewImageBack.startsWith('blob:')) {
            URL.revokeObjectURL(previewImageBack);
        }
    };

    generatePlaceholderPhoto = async () => {
        return new Promise((resolve) => {
            const canvas = document.createElement('canvas');
            canvas.width = 300;
            canvas.height = 400;
            const ctx = canvas.getContext('2d');

            // Fond gris
            ctx.fillStyle = '#E0E0E0';
            ctx.fillRect(0, 0, 300, 400);

            // Icône silhouette
            ctx.fillStyle = '#BDBDBD';
            ctx.beginPath();
            ctx.arc(150, 120, 50, 0, Math.PI * 2); // Tête
            ctx.fill();
            ctx.beginPath();
            ctx.ellipse(150, 250, 80, 100, 0, 0, Math.PI * 2); // Corps
            ctx.fill();

            // Texte
            ctx.fillStyle = '#757575';
            ctx.font = '16px Arial';
            ctx.textAlign = 'center';
            ctx.fillText('PHOTO', 150, 340);
            ctx.fillText('PREVIEW', 150, 360);

            // Convertir en base64 (sans le préfixe data:image)
            const base64 = canvas.toDataURL('image/png').split(',')[1];
            this.setState({ photoBase64: base64 }, resolve);
        });
    };

    loadPreview = async (side) => {
        const { template } = this.props;
        const { cardData, previewOptions, photoBase64, previewImageFront, previewImageBack } = this.state;

        if (!template || !template.id) return;

        // Clean up old object URL before loading new one
        if (side === 'Front' && previewImageFront && previewImageFront.startsWith('blob:')) {
            URL.revokeObjectURL(previewImageFront);
        } else if (side === 'Back' && previewImageBack && previewImageBack.startsWith('blob:')) {
            URL.revokeObjectURL(previewImageBack);
        }

        this.setState({ loadingPreview: true, previewError: null });

        try {
            const requestData = {
                templateId: String(template.id),
                cardData: {
                    ...cardData,
                    customFields: {
                        country: template.country || 'LB',
                        priority: 'Normal',
                        notes: 'Template preview',
                        PhotoUrl: photoBase64 || '' // Utiliser la vraie photo base64 générée
                    }
                },
                options: previewOptions,
                side: side // 'Front' or 'Back'
            };

            console.log('Preview request:', requestData);

            const response = await axios.post(
                `${API_BASE_URL}/api/cards/preview/card/image`,
                requestData,
                {
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    responseType: 'blob' // API returns PNG image directly
                }
            );

            console.log(`${side} preview response:`, response.data.type, response.data.size, 'bytes');

            // Create object URL from the blob
            const imageUrl = URL.createObjectURL(response.data);

            console.log(`${side} image URL created:`, imageUrl);

            if (side === 'Front') {
                this.setState({ previewImageFront: imageUrl });
            } else {
                this.setState({ previewImageBack: imageUrl });
            }

        } catch (error) {
            console.error(`Error loading ${side} preview:`, error);
            this.setState({
                previewError: `Failed to load ${side} preview: ${error.message}`
            });
        } finally {
            this.setState({ loadingPreview: false });
        }
    };

    refreshPreview = () => {
        this.loadPreview('Front');
        this.loadPreview('Back');
    };

    viewModeOptions = [
        { label: 'Front & Back', value: 'both' },
        { label: 'Front only', value: 'front' },
        { label: 'Back only', value: 'back' }
    ];

    zoomOptions = [
        { label: '50%', value: 50 },
        { label: '75%', value: 75 },
        { label: '100%', value: 100 },
        { label: '125%', value: 125 },
        { label: '150%', value: 150 },
        { label: '200%', value: 200 }
    ];

    renderCardSide = (side, template) => {
        const { zoomLevel, previewImageFront, previewImageBack, loadingPreview, previewError } = this.state;

        if (!template) return null;

        const imageUrl = side === 'front' ? previewImageFront : previewImageBack;

        return (
            <div style={{ display: 'inline-block', margin: '10px' }}>
                <h5 className="text-center mb-3">
                    {side === 'front' ? 'Front' : 'Back'}
                </h5>
                <div style={{
                    transform: `scale(${zoomLevel / 100})`,
                    transformOrigin: 'top center',
                    display: 'inline-block'
                }}>
                    {loadingPreview ? (
                        <div style={{
                            width: '350px',
                            height: '220px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            border: '2px dashed #ddd',
                            borderRadius: '12px'
                        }}>
                            <ProgressSpinner style={{ width: '50px', height: '50px' }} />
                        </div>
                    ) : previewError ? (
                        <div style={{
                            width: '350px',
                            height: '220px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            border: '2px solid #f44336',
                            borderRadius: '12px',
                            padding: '20px',
                            textAlign: 'center',
                            color: '#f44336'
                        }}>
                            <div>
                                <i className="pi pi-exclamation-triangle" style={{ fontSize: '2em', marginBottom: '10px' }}></i>
                                <p>{previewError}</p>
                            </div>
                        </div>
                    ) : imageUrl ? (
                        <img
                            src={imageUrl}
                            alt={`Card ${side}`}
                            style={{
                                maxWidth: '100%',
                                borderRadius: '12px',
                                boxShadow: '0 8px 16px rgba(0,0,0,0.3)'
                            }}
                        />
                    ) : (
                        <div style={{
                            width: '350px',
                            height: '220px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            border: '2px dashed #ddd',
                            borderRadius: '12px',
                            color: '#999'
                        }}>
                            No preview available
                        </div>
                    )}
                </div>
            </div>
        );
    };


    renderSampleDataEditor = () => {
        const { cardData } = this.state;

        const dataFields = [
            { key: 'firstName', label: 'First Name' },
            { key: 'name', label: 'Last Name' },
            { key: 'idNumber', label: 'ID Number' },
            { key: 'policeNumber', label: 'Police Number' },
            { key: 'souscripteur', label: 'Subscriber' },
            { key: 'serialNumber', label: 'Serial Number' },
            { key: 'nationality', label: 'Nationality' },
            { key: 'insuranceCompany', label: 'Insurance Company' },
            { key: 'policyType', label: 'Policy Type' }
        ];

        return (
            <Panel header="Test Data" toggleable>
                <div className="p-fluid">
                    <Row>
                        {dataFields.map((field, index) => (
                            <Col md={12} key={index} className="mb-3">
                                <label htmlFor={field.key} className="font-semibold small">
                                    {field.label}
                                </label>
                                <InputText
                                    id={field.key}
                                    value={cardData[field.key] || ''}
                                    onChange={(e) => this.setState(prev => ({
                                        cardData: {
                                            ...prev.cardData,
                                            [field.key]: e.target.value
                                        }
                                    }))}
                                    type={field.type || 'text'}
                                />
                            </Col>
                        ))}
                    </Row>
                    <Button
                        label="Refresh Preview"
                        icon="pi pi-refresh"
                        className="p-button-outlined mt-2 w-100"
                        onClick={this.refreshPreview}
                    />
                </div>
            </Panel>
        );
    };

    renderPreviewControls = () => {
        const { viewMode, zoomLevel } = this.state;

        return (
            <div className="flex justify-content-between align-items-center mb-4 p-3 border-round surface-100">
                <div className="flex gap-3 align-items-center">
                    <label className="font-semibold">Display:</label>
                    <Dropdown
                        value={viewMode}
                        options={this.viewModeOptions}
                        onChange={(e) => this.setState({ viewMode: e.value })}
                        style={{ width: '200px' }}
                    />
                </div>
                <div className="flex gap-3 align-items-center">
                    <label className="font-semibold">Zoom:</label>
                    <Dropdown
                        value={zoomLevel}
                        options={this.zoomOptions}
                        onChange={(e) => this.setState({ zoomLevel: e.value })}
                        style={{ width: '100px' }}
                    />
                </div>
                <div className="flex gap-2">
                    <Button
                        icon="pi pi-refresh"
                        label="Refresh"
                        className="p-button-outlined"
                        onClick={this.refreshPreview}
                    />
                </div>
            </div>
        );
    };

    render() {
        const { visible, onHide, template } = this.props;
        const { viewMode } = this.state;

        if (!template) return null;

        return (
            <Dialog
                visible={visible}
                style={{ width: '90vw', height: '90vh' }}
                header={`Preview - ${template.name}`}
                modal
                onHide={onHide}
                maximizable
                footer={
                    <div>
                        <Button
                            label="Close"
                            icon="pi pi-times"
                            className="p-button-text"
                            onClick={onHide}
                        />
                        <Button
                            label="Edit Template"
                            icon="pi pi-pencil"
                            onClick={() => {
                                onHide();
                                // Ouvrir l'éditeur
                            }}
                        />
                    </div>
                }
            >
                <div className="template-preview-container">
                    {this.renderPreviewControls()}

                    <Divider />

                    <Row>
                        <Col lg={8}>
                            <Card title="Card Preview" className="mb-4">
                                <div className="text-center" style={{ minHeight: '300px', padding: '20px' }}>
                                    {(viewMode === 'both' || viewMode === 'front') &&
                                        this.renderCardSide('front', template)
                                    }
                                    {(viewMode === 'both' || viewMode === 'back') &&
                                        this.renderCardSide('back', template)
                                    }
                                </div>
                            </Card>
                        </Col>
                        <Col lg={4}>
                            <Card title="Template Information" className="mb-4">
                                <div className="template-info">
                                    <div className="field">
                                        <label className="font-semibold">Name:</label>
                                        <p>{template.name}</p>
                                    </div>
                                    <div className="field">
                                        <label className="font-semibold">Country:</label>
                                        <p>{template.country}</p>
                                    </div>
                                    <div className="field">
                                        <label className="font-semibold">Version:</label>
                                        <p>{template.version}</p>
                                    </div>
                                    <div className="field">
                                        <label className="font-semibold">Uses:</label>
                                        <p>{template.usageCount}</p>
                                    </div>
                                    <div className="field">
                                        <label className="font-semibold">Status:</label>
                                        <p>{template.isActive ? 'Active' : 'Inactive'}</p>
                                    </div>
                                </div>
                            </Card>

                            {this.renderSampleDataEditor()}
                        </Col>
                    </Row>
                </div>
            </Dialog>
        );
    }
}

export default TemplatePreview;